{
  "actions": {
    "save": "Uložit",
    "saving": "Ukládám...",
    "cancel": "Zrušit",
    "delete": "Smazat",
    "remove": "Odebrat",
    "create": "Vytvořit",
    "edit": "Upravit",
    "add": "Přidat",
    "new": "Nový",
    "newFem": "Nová",
    "close": "Zavřít",
    "back": "Zpět",
    "next": "Další",
    "confirm": "Potvrdit",
    "search": "Hledat",
    "refresh": "Obnovit",
    "retry": "Zkusit znovu",
    "reset": "Resetovat",
    "submit": "Odeslat",
    "apply": "Použít",
    "duplicate": "Duplikovat",
    "export": "Exportovat",
    "import": "Importovat",
    "select": "Vybrat",
    "selectAll": "Vybrat vše",
    "deselectAll": "Zrušit výběr",
    "enable": "Zapnout",
    "disable": "Vypnout",
    "start": "Spustit",
    "stop": "Zastavit",
    "pause": "Pozastavit",
    "resume": "Pokračovat",
    "finish": "Dokončit",
    "skip": "Přeskočit",
    "showMore": "Zobrazit více",
    "showLess": "Zobrazit méně",
    "viewAll": "Zobrazit vše",
    "viewDetail": "Zobrazit detail",
    "goBack": "Jít zpět",
    "upload": "Nahrát",
    "download": "Stáhnout",
    "copy": "Kopírovat",
    "filter": "Filtrovat",
    "sort": "Řadit",
    "configure": "Nastavit",
    "test": "Otestovat",
    "calibrate": "Seřídit",
    "acknowledge": "Vzít na vědomí",
    "resolve": "Vyřešit",
    "dismiss": "Zamítnout"
  },
  "status": {
    "loading": "Načítám data...",
    "loadingShort": "Načítám...",
    "saving": "Ukládám...",
    "error": "Chyba",
    "success": "Úspěch",
    "active": "Aktivní",
    "inactive": "Neaktivní",
    "online": "Funguje",
    "offline": "Nepřipojeno",
    "enabled": "Zapnuto",
    "disabled": "Vypnuto",
    "pending": "Čeká",
    "completed": "Dokončeno",
    "failed": "Selhalo",
    "unknown": "Neznámý",
    "noResults": "Žádné výsledky",
    "noData": "Žádná data",
    "empty": "Prázdné",
    "healthy": "V pořádku",
    "warning": "Varování",
    "critical": "Kritické",
    "connected": "Připojeno",
    "disconnected": "Odpojeno"
  },
  "confirm": {
    "deleteTitle": "Smazat {{item}}?",
    "deleteDesc": "Tato akce je nevratná.",
    "unsavedChanges": "Máte neuložené změny. Opravdu chcete odejít?",
    "areYouSure": "Opravdu chcete pokračovat?"
  },
  "labels": {
    "name": "Název",
    "description": "Popis",
    "type": "Typ",
    "status": "Stav",
    "date": "Datum",
    "from": "Od",
    "to": "Do",
    "notes": "Poznámky",
    "category": "Kategorie",
    "priority": "Priorita",
    "device": "Zařízení",
    "sensor": "Čidlo",
    "value": "Hodnota",
    "unit": "Jednotka",
    "min": "Min",
    "max": "Max",
    "average": "Průměr",
    "total": "Celkem",
    "count": "Počet",
    "duration": "Doba trvání",
    "frequency": "Frekvence",
    "interval": "Interval",
    "threshold": "Práh",
    "limit": "Limit",
    "target": "Cíl",
    "current": "Aktuální",
    "previous": "Předchozí",
    "details": "Detaily",
    "settings": "Nastavení",
    "actions": "Akce",
    "createdAt": "Vytvořeno",
    "updatedAt": "Aktualizováno",
    "lastTriggered": "Naposledy spuštěno",
    "version": "Verze",
    "size": "Velikost",
    "photo": "Fotografie",
    "photos": "Fotografie"
  },
  "time": {
    "hour": "hodina",
    "hours": "hodin",
    "day": "den",
    "days": "dní",
    "week": "týden",
    "weeks": "týdnů",
    "month": "měsíc",
    "months": "měsíců",
    "minute": "minuta",
    "minutes": "minut",
    "second": "sekunda",
    "seconds": "sekund",
    "hourly": "Hodinový",
    "daily": "Denní",
    "weekly": "Týdenní",
    "monthly": "Měsíční",
    "today": "Dnes",
    "yesterday": "Včera",
    "tomorrow": "Zítra",
    "now": "Nyní",
    "ago": "před"
  },
  "errors": {
    "generic": "Došlo k neočekávané chybě.",
    "network": "Chyba připojení k serveru.",
    "notFound": "Požadovaný záznam nebyl nalezen.",
    "unauthorized": "Nemáte oprávnění k této akci.",
    "validation": "Zkontrolujte zadané údaje.",
    "loadFailed": "Nepodařilo se načíst data.",
    "saveFailed": "Nepodařilo se uložit změny.",
    "deleteFailed": "Nepodařilo se smazat záznam.",
    "tryAgain": "Zkuste to prosím znovu."
  },
  "preferences": {
    "appearanceAndLanguage": "Vzhled a jazyk",
    "colorMode": "Barevný režim",
    "themeLight": "Světlý",
    "themeDark": "Tmavý",
    "themeSystem": "Systém",
    "language": "Jazyk",
    "timezone": "Časové pásmo",
    "quietHours": "Nerušit (Quiet Hours)",
    "quietHoursDesc": "Během této doby nebudete dostávat žádné notifikace s nízkou nebo střední prioritou. Kritické alerty budou stále doručeny.",
    "advancedNotifications": "Pokročilé nastavení notifikací"
  },
  "nav": {
    "dashboard": "Přehled",
    "myGarden": "Moje zahrada",
    "growingAreas": "Záhony",
    "reservoirs": "Nádrže",
    "batches": "Výsadby",
    "planning": "Plánování",
    "cropPlans": "Plány pěstování",
    "tasks": "Úkoly",
    "scheduler": "Plánovač",
    "journal": "Deník",
    "library": "Knihovna",
    "plantopedia": "Plant-O-Pedia",
    "recipes": "Recepty",
    "automation": "Automatizace",
    "rules": "Pravidla",
    "safety": "Hlídači",
    "violations": "Historie porušení",
    "analytics": "Analytika",
    "settings": "Nastavení",
    "controls": "Ovládání",
    "dosing": "Výživa rostlin",
    "sensors": "Čidla",
    "devices": "Zařízení",
    "profile": "Profil",
    "notifications": "Upozornění",
    "help": "Nápověda",
    "logout": "Odhlásit se",
    "more": "Více",
    "monitoring": "Monitorování",
    "growing": "Pěstování",
    "calendar": "Kalendář",
    "interlocks": "Interlocky",
    "interlockLog": "Log ochran",
    "interlockOverrides": "Admin přepisy",
    "service": "Servis"
  },
  "validation": {
    "required": "Toto pole je povinné.",
    "minLength": "Minimálně {{min}} znaků.",
    "maxLength": "Maximálně {{max}} znaků.",
    "invalidEmail": "Neplatná e-mailová adresa.",
    "invalidNumber": "Zadejte platné číslo.",
    "minValue": "Minimální hodnota je {{min}}.",
    "maxValue": "Maximální hodnota je {{max}}.",
    "passwordMismatch": "Hesla se neshodují."
  },
  "pagination": {
    "page": "Strana",
    "of": "z",
    "itemsPerPage": "Záznamů na stránku",
    "showing": "Zobrazeno {{from}}-{{to}} z {{total}}",
    "first": "První",
    "last": "Poslední",
    "previous": "Předchozí",
    "next": "Další"
  },
  "not_specified": "Nespecifikováno"
}
